module.exports = __webpack_public_path__ + "img/transforme-sua-carreira.8e567ddf.png";